import {
  collectAssessmentData,
  getLastAssessmentResult,
} from "../pages/assessment.ts";

// Initialize PDF Download functionality
export function initPDFDownload(): void {
  const downloadBtn = document.getElementById("download-pdf-btn");
  if (!downloadBtn) return;

  downloadBtn.addEventListener("click", async () => {
    const processNameInput = document.getElementById(
      "process-name",
    ) as HTMLInputElement;

    if (!processNameInput?.value?.trim()) {
      processNameInput?.focus();
      processNameInput?.classList.add(
        "ring-2",
        "ring-red-500",
        "border-red-500",
      );
      setTimeout(() => {
        processNameInput?.classList.remove(
          "ring-2",
          "ring-red-500",
          "border-red-500",
        );
      }, 2000);
      return;
    }

    const data = collectAssessmentData();
    const assessmentResult = getLastAssessmentResult();
    const payload = assessmentResult ? { ...data, assessmentResult } : data;

    const defaultContent = document.getElementById("download-pdf-btn-default");
    const loadingContent = document.getElementById("download-pdf-btn-loading");

    try {
      downloadBtn.classList.add("opacity-75", "cursor-wait");
      (downloadBtn as HTMLButtonElement).disabled = true;
      defaultContent?.classList.add("hidden");
      loadingContent?.classList.remove("hidden");

      const response = await fetch("/api/generate-pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to generate PDF");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${
        data.processName.replace(/[^a-zA-Z0-9]/g, "_")
      }_assessment.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("PDF download error:", error);
      alert("Failed to generate PDF. Please try again.");
    } finally {
      downloadBtn.classList.remove("opacity-75", "cursor-wait");
      (downloadBtn as HTMLButtonElement).disabled = false;
      defaultContent?.classList.remove("hidden");
      loadingContent?.classList.add("hidden");
    }
  });
}
